var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c(
        "LoginCard",
        { attrs: { header: _vm.headerText } },
        [
          _c("Alert", {
            attrs: { centered: "" },
            model: {
              value: _vm.errorMessage,
              callback: function ($$v) {
                _vm.errorMessage = $$v
              },
              expression: "errorMessage",
            },
          }),
          _vm._v(" "),
          _c("Credentials", {
            ref: _vm.formRef,
            attrs: {
              action: _vm.authURL,
              form: _vm.form,
              isAdmin: false,
              isLoading: _vm.isLoading,
              submit: _vm.submit,
              submitButtonText: _vm.submitButtonText,
            },
          }),
          _vm._v(" "),
          _c("div", { ref: "resetPassword", class: _vm.$style.resetPassword }, [
            _c(
              "span",
              {
                class: _vm.$style.resetPasswordLink,
                on: {
                  click: function ($event) {
                    return _vm.redirect(_vm.resetPasswordRoute)
                  },
                },
              },
              [_vm._v("\n        Reset User Password\n      ")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }